import { useEffect, useState } from "react";

const HOUR_MS = 60 * 60 * 1000;
const PLAY_STEP_MS = 1200;

// Every full hour today up to the current one. Icelandic time is UTC.
export const todayHours = (now = Date.now()) => {
  const midnight = new Date(now).setUTCHours(0, 0, 0, 0);
  const hours = [];
  for (let t = midnight; t <= now; t += HOUR_MS) hours.push(t);
  return hours;
};

export const formatHour = (ms) =>
  `${String(new Date(ms).getUTCHours()).padStart(2, "0")}:00`;

// Scrub through today, hour by hour. `hours` are the past hours with data;
// the last step is "Now", the live view. `value` is null there and the hour
// (ms since epoch) otherwise.
export const Timeline = ({ hours, value, onChange, loading }) => {
  const [playing, setPlaying] = useState(false);
  const last = hours.length; // index of "Now"
  const index = value === null ? last : Math.max(0, hours.indexOf(value));
  const select = (i) => onChange(i >= last ? null : hours[i]);

  useEffect(() => {
    if (!playing) return undefined;
    const timer = setTimeout(() => {
      if (index >= last) setPlaying(false);
      else select(index + 1);
    }, PLAY_STEP_MS);
    return () => clearTimeout(timer);
  });

  const togglePlay = () => {
    // Playing from "Now" starts again at midnight
    if (!playing && index >= last) select(0);
    setPlaying(!playing);
  };

  const label = value === null ? "Now" : formatHour(value);

  return (
    <div className="aq-panel aq-panel--timeline">
      <button
        type="button"
        className="aq-timeline__play"
        onClick={togglePlay}
        aria-label={playing ? "Pause" : "Play today"}
      >
        {playing ? "❚❚" : "▶"}
      </button>
      <div className="aq-timeline__track">
        <input
          type="range"
          min={0}
          max={last}
          step={1}
          value={index}
          onChange={(e) => {
            setPlaying(false);
            select(Number(e.target.value));
          }}
          aria-label="Time today"
          aria-valuetext={label}
        />
        <div className="aq-timeline__ticks" aria-hidden="true">
          {[0, 6, 12, 18].map((hour) => {
            // Place each tick at its hour's step; hours with no data are
            // skipped, so steps aren't always one per clock hour
            const i = hours.findIndex(
              (t) => new Date(t).getUTCHours() === hour,
            );
            return i < 0 ? null : (
              <span key={hour} style={{ left: `${(i / last) * 100}%` }}>
                {String(hour).padStart(2, "0")}
              </span>
            );
          })}
        </div>
      </div>
      <span className="aq-mono aq-timeline__label" aria-live="polite">
        {loading ? "…" : label}
      </span>
    </div>
  );
};
